// A téma-választó — HÁROM mód: világos · sötét · rendszer szerint (Dóri/Ilcsa #50). EGY helyen él: a belső
// profil-menü a `ThemeModeItems`-t ágyazza be, a partner-portál fejléce a `ThemeToggle` ikon-gomb menüjét használja.
import { ComputerDesktopIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import { type Theme, useTheme } from '@/components/theme-provider';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const THEME_MODES: readonly { mode: Theme; icon: typeof SunIcon }[] = [
  { mode: 'light', icon: SunIcon },
  { mode: 'dark', icon: MoonIcon },
  { mode: 'system', icon: ComputerDesktopIcon },
];

/**
 * A három mód pipálható menü-elemként (a kiválasztott pipát kap). A kattintás NEM zárja a menüt — a hatás azonnal
 * látszik, a felhasználó tovább válthat.
 */
export function ThemeModeItems(): JSX.Element {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  return (
    <>
      <DropdownMenuLabel className="text-muted-foreground text-xs font-normal">
        {t('theme.title')}
      </DropdownMenuLabel>
      {THEME_MODES.map(({ mode, icon: Icon }) => (
        <DropdownMenuCheckboxItem
          key={mode}
          checked={theme === mode}
          onSelect={(e) => e.preventDefault()}
          onCheckedChange={() => setTheme(mode)}
        >
          <Icon />
          {t(`theme.${mode}`)}
        </DropdownMenuCheckboxItem>
      ))}
    </>
  );
}

/** Ikon-gomb (a ténylegesen alkalmazott téma ikonjával) → a három mód menüje. */
export function ThemeToggle(): JSX.Element {
  const { resolvedTheme } = useTheme();
  const { t } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('theme.toggle')}>
          {resolvedTheme === 'dark' ? <MoonIcon /> : <SunIcon />}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <ThemeModeItems />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
